// Translation for tr
export const tr = {
        common: {
            save: 'Kaydet',
            cancel: 'İptal',
            close: 'Kapat',
            delete: 'Sil',
            edit: 'Düzenle',
            activate: 'Etkinleştir',
            add: 'Ekle',
            saving: 'Kaydediliyor...',
            loading: 'Yükleniyor...',
            active: 'AKTİF',
            inUse: 'Kullanımda',
            test: 'Test',
            searchApps: 'Uygulamaları ara...',
            betaBanner: 'BETA - Hizmet henüz mevcut değil!'
        },
        header: {
            creditBalance: 'Bakiye',
            minutes: 'DAK'
        },
        auth: {
            signIn: 'Giriş Yap',
            signUp: 'Kaydol',
            username: 'Kullanıcı Adı',
            password: 'Şifre',
            continue: 'Devam Et',
            noAccount: 'Hesabınız yok mu?',
            hasAccount: 'Zaten bir hesabınız var mı?',
            loginError: 'Giriş başarısız',
            invalidCredentials: 'Geçersiz kullanıcı adı veya şifre',
            rateLimited: 'Çok fazla giriş denemesi. Lütfen biraz bekleyin.',
            sessionExpired: 'Oturumunuz sona erdi. Lütfen yeni bir sihirli bağlantı kullanın.',
            magicLinkInvalid: 'Giriş bağlantısı geçersiz veya süresi dolmuş.',
            magicLinkSuccess: 'Hoş geldiniz! Başarıyla giriş yaptınız.',
            magicLinkProcessing: 'Giriş işleniyor...',
            connectionError: 'Bağlantı hatası. Lütfen tekrar deneyin.'
        },
        profile: {
            myProgress: 'Öğrenme İlerlememiz',
            signOut: 'Çıkış Yap',
            plan: 'Plan: '
        },
        settings: {
            title: 'Ayarlar',
            tabs: {
                uiSettings: 'UI Ayarları',
                systemPrompt: 'Sistem İstemi',
                llmProfiles: 'LLM Profilleri',
                ttsProfiles: 'TTS Profilleri',
                language: 'Dil',
            },
            uiSettings: {
                title: 'Kullanıcı Arayüzü',
                themeMode: 'Tema Modu',
                darkMode: 'Karanlık Mod',
                lightMode: 'Aydınlık Mod',
                themeColor: 'Tema Rengi',
                themeColorDesc: 'Butonlar, simgeler ve vurgular için vurgu rengini seçin',
                background: 'Arka Plan',
                backgroundDesc: 'Çalışma alanınız için bir arka plan seçin',
                selectBackgroundColor: 'Arka Plan Rengi Seç',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Odaklanma',
                    concentration: 'Konsantrasyon',
                    relaxation: 'Rahatlama',
                    lianas: 'Sarmaşıklar',
                    color: 'Renk'
                },
                backgroundColors: {
                    deepDark: 'Derin Karanlık',
                    darkGrey: 'Koyu Gri',
                    midnightBlue: 'Gece Mavisi',
                    indigo: 'Çivit',
                    darkTeal: 'Koyu Deniz Mavisi',
                    brown: 'Kahverengi',
                    darkRed: 'Koyu Kırmızı',
                    deepPurple: 'Derin Mor',
                    pureWhite: 'Saf Beyaz',
                    softWhite: 'Yumuşak Beyaz',
                    lightGrey: 'Açık Gri',
                    paleBlue: 'Soluk Mavi',
                    paleGreen: 'Soluk Yeşil',
                    paleOrange: 'Soluk Turuncu',
                    lavender: 'Lavanta',
                    blueGrey: 'Mavi Gri'
                }
            },
            systemPrompt: {
                label: 'Sistem İstemi:',
                placeholder: 'Sistem istemi yükleniyor...',
                emptyError: 'Sistem istemi boş olamaz!',
                saveSuccess: '✓ Sistem istemi başarıyla kaydedildi!',
                loadError: 'Sistem istemi yüklenirken hata',
                saveError: 'Kaydederken hata'
            },
            llmProfiles: {
                addButton: '+ Yeni Bağlantı Ekle',
                newConnection: 'Yeni Bağlantı',
                editConnection: 'Bağlantıyı Düzenle',
                emptyState: 'LLM bağlantısı yok. Eklemek için aşağıya tıklayın.',
                loadingProfiles: 'Profiller yükleniyor...',
                nameLabel: 'İsim *',
                namePlaceholder: 'örn. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API Anahtarı *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, vb.',
                allFieldsRequired: 'Tüm alanlar doldurulmalıdır!',
                saveSuccess: '✓ Profil başarıyla kaydedildi!',
                deleteConfirm: '"{name}" adlı profili gerçekten silmek istiyor musunuz?',
                profileNotFound: 'Profil bulunamadı!',
                loadError: 'Profiller yüklenirken hata',
                saveError: 'Kaydederken hata',
                activateError: 'Etkinleştirirken hata',
                deleteError: 'Silerken hata',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Yeni Ses Ekle',
                newVoice: 'Yeni Ses',
                editVoice: 'Sesi Düzenle',
                emptyState: 'TTS profili yok. Eklemek için aşağıya tıklayın.',
                loadingProfiles: 'TTS profilleri yükleniyor...',
                nameLabel: 'İsim',
                namePlaceholder: 'örn. Benim ElevenLabs Adam',
                providerLabel: 'Sağlayıcı',
                providerPlaceholder: 'örn. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Yerel)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API Anahtarı *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Model ID *',
                modelIdPlaceholder: 'örn. eleven_monolingual_v1',
                voiceIdLabel: 'Ses ID',
                voiceIdPlaceholder: 'örn. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Tüm alanlar doldurulmalıdır!',
                saveSuccess: '✓ TTS profili başarıyla kaydedildi!',
                deleteConfirm: '"{name}" adlı profili gerçekten silmek istiyor musunuz?',
                loadError: 'TTS profilleri yüklenirken hata',
                saveError: 'Kaydederken hata',
                activateError: 'Etkinleştirirken hata',
                deleteError: 'Silerken hata'
            },
            language: {
                title: 'Dil Seçin',
                description: 'Kullanıcı arayüzü için tercih ettiğiniz dili seçin'
            },
        },
        chat: {
            ready: 'Hazır',
            start: 'BAŞLAT',
            stop: 'DURDUR',
            initialMessage: 'Gerçek zamanlı sohbet için BAŞLAT\'a tıklayın.',
            listening: 'Dinliyor...',
            speaking: 'Thorsten konuşuyor...',
            userLabel: 'Sen',
            aiLabel: 'Yapay Zeka',
            modalTitle: 'Thorsten AI Sohbet',
            inputPlaceholder: 'Bir mesaj yazın...',
            send: 'Gönder',
            loginRequired: 'Bu hizmeti kullanmak için lütfen oturum açın.',
            loginButton: 'Şimdi oturum aç',
            magicLinkRequired: 'Giriş yapmak için lütfen sihirli bir bağlantı kullanın.',
            creditLimitError: 'Saatlik kotanız tükendi. Devam etmek için planınızı (Medium/Premium) yükseltin.',
            serviceDisabled: 'Sohbet hizmeti şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyin.'
        },
        notifications: {
            error: 'Hata',
            success: 'Başarılı',
            info: 'Bilgi',
            unknownError: 'Bilinmeyen bir hata oluştu'
        },
        cookie: {
            message: 'Bu web sitesi size en iyi kullanıcı deneyimini sağlamak için çerezler kullanmaktadır.',
            accept: 'Kabul Et'
        },
        curriculum: {
                buttonLabel: 'Müfredat',
                buttonTitle: 'Müfredat içeriğini göster',
                modalTitle: '{app} Müfredatı',
                sections: {
                    topic: 'Müfredat konusu',
                    explanation: 'Çocuk dostu açıklama',
                    chat: 'Yapay zekâya soru sor',
                    studentProfile: 'Öğrenci profili'
                },
                chat: {
                    hint: 'Bu müfredat konusu hakkında bir soru sor. Yapay zekâ, neden önemli olduğunu anlamana yardım eder.',
                    placeholder: 'Sorunu yaz …',
                    inputAria: 'Yapay zekâya soru',
                    send: 'Gönder',
                    sending: 'Gönderiliyor …',
                    empty: 'Yapay zekâ yanıt vermedi. Lütfen tekrar dene.',
                    noTopic: 'Soru sormak için müfredat içeriği mevcut değil.',
                    requestFailed: 'Yanıt oluşturulamadı.'
                },
                topic: {
                    empty: 'Bu mikro uygulamaya arka uçta herhangi bir müfredat konusu bağlı değil.',
                    missingDetail: 'Bu mikro uygulama için ayrıntılı müfredat verileri arka uçta henüz mevcut değil.',
                    learningGoals: 'Öğrenme hedefleri',
                    prerequisites: 'Ön koşullar',
                    unitLabel: 'Ünite',
                    durationLabel: 'Süre',
                    difficultyLabel: 'Zorluk',
                    hours: 'sa',
                    minutes: 'dk'
                },
                explanation: {
                    empty: 'Çocuk dostu açıklama mevcut değil.',
                    loadingPrepare: 'Yapay zeka açıklamayı hazırlıyor',
                    loadingExplain: 'Yapay zeka konuyu çocuk dostu dille açıklıyor',
                    requestFailed: 'Çocuk dostu açıklama oluşturulamadı.'
                },
                studentProfile: {
                    country: 'Ülke',
                    region: 'Eyalet / Bölge',
                    schoolType: 'Okul türü',
                    grade: 'Sınıf',
                    noContext: 'Öğrenci bağlamı mevcut değil.',
                    childProfileNotFound: 'Mevcut oturum için arka uçta öğrenci profili bulunamadı.',
                    loginProfileIncomplete: 'Oturum profili henüz tam bir öğrenci bağlamı içermiyor.',
                    educationContextNotFound: 'Bir öğrenci profili bulundu ancak müfredat ataması yapılmamış.',
                    noToken: 'Oturum açmış öğrenci bulunamadı.'
                },
                errors: {
                    signInRequired: 'Müfredatı görüntülemek için lütfen oturum açın.',
                    appIdMissing: 'Uygulama kimliği eksik.',
                    loadFailed: 'Müfredat verileri yüklenemedi.'
                }
            }
    };
